import {dataFetcher} from "../../services/dataGuetter/dataFetcher";

/**
* Permet de se connecter via l'adresse mail et le mot de passe, retourne un objet content le jwt.
* @param username
* @param password
*/
export function login(username: string, password: string) {
    return dataFetcher("login", {
        method: "POST",
        body: {
            username: username,
            password: password,
        },
    });
}

export function saveOptin(id:number):Promise<User>{
    return dataFetcher(`users/${id}`, {
        method:'put',
        body:{optIn:true}
    })
}

export function checkMD(pwd:string){
    return dataFetcher(`mobile/check_mdp`, {
        method:"post",
        body:{mdp:pwd}
    })
}

export function changePwd2(pwd:string){
    return dataFetcher(`mobile/change_mdp`, {
        method: "POST",
        body: {
            mdp: pwd,
        },
    });
}

export function changePwd(id:number,old:string, pwd:string){
    return dataFetcher("users/"+id+"/change_pwd", {
        method: "POST",
        body: {
            old: old,
            pwd: pwd,
        },
    });
}

export function getInfosUser():Promise<User>{
    return dataFetcher(`me2`, {
        method:'get',
    })
}

export function getInfosUserMob():Promise<User>{
    return dataFetcher(`mobile/get_user`, {method:'get'})
}

export function getUserSignature():Promise<UserSignature|null>{
    return dataFetcher(`mobile/get_user_signature`)
}

export async function getUsersByCentre():Promise<UserAnnuaire[]>{
    return await dataFetcher(`mobile/get_all_user`, {method:'get'});
}

export function getUsersQuicks():Promise<UserQuick[]>{
    return dataFetcher(`users_trombi`)
}

export async function getUsersByCentreBorn():Promise<UserBirth[]>{
    const res:any = await dataFetcher(`users/births?isMobile=1`, {method:'get'});
    return res["hydra:member"];
}

export function modifyCoord(datas:ModifyUserFD, id:number):Promise<User>{
    return dataFetcher(`users/${id}`, {
        method:'put',
        body:datas
    })
}

export function forgot_pwd(username:string):Promise<any>{
    return dataFetcher('users/forgot_pwd', {
        method:'post',
        body:{username:username}
    })
}

export function trashUserSignature(id:number):Promise<any>{
    return dataFetcher(`user_signatures/${id}`, {method:'DELETE'});
}

export function addUserSignature(datas:PostNewSignature):Promise<UserDocument>{
    const formData = new FormData();
    for (const [key, value] of Object.entries(datas)){
        formData.append(`${key}`, value);
    }
    return dataFetcher<UserDocument>(
        `user_signatures/postOne`,
        {
            method: "POST",
            body: formData,
        },
        true
    );
}

export async function getUsersShadow(nom:string):Promise<UserShadow[]>{
    return await dataFetcher(`mobile/get_user_shadow?nom=${nom}`)
}

export function postWMSub(datas:WMsubFormData):Promise<any>{
    return dataFetcher(`web_master_substitutes`, {
        method:"post",
        body:datas
    })
}

export function CancelSub():Promise<any>{
    return dataFetcher(`web_master_substitutes/cancel_mobile`, {
        method:"get",
    })
}

export const SubscribePush = async (userId:any):Promise<any>=>{
    return dataFetcher(`users/subscribe_signal`, {
        method:'post',
        body: {oneSignalId: userId}
    })
}
